<template>
    <div>
        <!-- 阿富汗进口提单明细/没有出口 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                        <th width="25%">起运港</th>
                        <td width="25%">{{billInfo.LoadingPort}}</td>
                    </tr>
                    <tr>
                        <th width="25%">目的港</th>
                        <td width="25%">{{billInfo.Ladingport}}</td>
                        <th width="25%">航线</th>
                        <td width="25%">{{billInfo.ShippingLine}}</td>
                    </tr>
                    <tr>
                        <th>航次</th>
                        <td>{{billInfo.ShippingNumber}}</td>
                        <th>提单号</th>
                        <td>{{billInfo.BillNumber}}</td>
                    </tr>
                    <tr>
                        <th>船务代理</th>
                        <td>{{billInfo.ShippingAgency}}</td>
                        <th>集装箱数量</th>
                        <td>{{billInfo.ContainerNumber}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
        
    </div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>